import { withCallAPI } from '01_core/components/system/CallAPI';
import { withCodeUtil } from '01_core/components/system/CodeUtil';
import { LABEL } from '01_core/constants/labelConsts';
import dateUtil from '01_core/logics/dateUtil';
import moment from 'moment';
import React from 'react';
import { injectIntl } from 'react-intl';

import { styled } from '@mui/material/styles';
import withResponsive from '01_core/hooks/withResponsive';

import { styles } from '../styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledNewIcon = styled('span')(({ theme }) => stylesFromTheme(theme).newIcon || {});

export class NewInfo extends React.Component {
  render() {
    const { intl, isDisplay } = this.props;

    if (!isDisplay) {
      return null;
    }

    return <StyledNewIcon>{intl.formatMessage({ id: LABEL.COMMON_NEW_INFO })}</StyledNewIcon>;
  }
}

export const checkNewInfo = (registerDt, kbn, lsKey, checkDays) => {
  if (
    !moment(registerDt, dateUtil.DATETIME_FORMAT)
      .add(checkDays, 'days')
      .isBefore(moment(dateUtil.getCurrentDateTime(), dateUtil.DATETIME_FORMAT))
  ) {
    // 登録日時から7日経っていない場合
    if (localStorage.getItem(lsKey + kbn)) {
      // ローカルストレージにデータがある場合
      // 登録日時が参照日時以前の場合
      return !moment(registerDt, dateUtil.DATETIME_FORMAT).isSameOrBefore(
        moment(localStorage.getItem(lsKey + kbn), dateUtil.DATETIME_FORMAT),
      );
    } else {
      // ローカルストレージにデータがない場合：未読
      return true;
    }
  } else {
    return false;
  }
};

export default withResponsive(injectIntl(withCallAPI(withCodeUtil(NewInfo))));
